module.exports = __webpack_public_path__ + "assets/img/logo.d1fa20dc.png";